if (!window.__krdsCromptonAnchorScrollBound) {
  window.__krdsCromptonAnchorScrollBound = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.krds-crompton a[href^="#"]');
    if (!link) return;
    const id = link.getAttribute('href').slice(1);
    if (!id) return;
    const target = document.getElementById(id);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}

function makeDraggable(el) {
  const THRESHOLD = 8;
  let pointerId = null;
  let startX = 0;
  let startScroll = 0;
  let dragging = false;

  const onPointerDown = (event) => {
    if (event.pointerType === 'touch') return;
    if (event.button !== 0) return;
    pointerId = event.pointerId;
    startX = event.clientX;
    startScroll = el.scrollLeft;
    dragging = false;
  };

  const onPointerMove = (event) => {
    if (pointerId === null || event.pointerId !== pointerId) return;
    const dx = event.clientX - startX;
    if (!dragging) {
      if (Math.abs(dx) <= THRESHOLD) return;
      dragging = true;
      el.setPointerCapture(pointerId);
      el.classList.add('is-dragging');
    }
    el.scrollLeft = startScroll - dx;
  };

  const onPointerUp = (event) => {
    if (pointerId === null || event.pointerId !== pointerId) return;
    if (dragging && el.hasPointerCapture(pointerId)) el.releasePointerCapture(pointerId);
    dragging = false;
    pointerId = null;
    el.classList.remove('is-dragging');
  };

  el.addEventListener('pointerdown', onPointerDown);
  el.addEventListener('pointermove', onPointerMove);
  el.addEventListener('pointerup', onPointerUp);
  el.addEventListener('pointercancel', onPointerUp);

  return () => {
    el.removeEventListener('pointerdown', onPointerDown);
    el.removeEventListener('pointermove', onPointerMove);
    el.removeEventListener('pointerup', onPointerUp);
    el.removeEventListener('pointercancel', onPointerUp);
  };
}

if (!customElements.get('krds-crompton-filter')) {
  class CromptonFilter extends HTMLElement {
    constructor() {
      super();
      this.pills = Array.from(this.querySelectorAll('[data-krds-crompton-pill]'));
      this.track = this.querySelector('[data-krds-crompton-track]');
      this.pillsRow = this.querySelector('[data-krds-crompton-pills]');
      this.tiles = this.track ? Array.from(this.track.querySelectorAll('[data-krds-crompton-tile]')) : [];
      this.onPillClick = this.onPillClick.bind(this);
      this.dragCleanups = [];
    }

    connectedCallback() {
      this.pills.forEach((pill) => pill.addEventListener('click', this.onPillClick));
      if (this.track) this.dragCleanups.push(makeDraggable(this.track));
      if (this.pillsRow) this.dragCleanups.push(makeDraggable(this.pillsRow));
      this.centerTrack();
      this.updateCentering();
      this._onCenterResize = () => this.updateCentering();
      window.addEventListener('resize', this._onCenterResize);
    }

        centerTrack() {
      if (!this.track) return;
      const set = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (max <= 0) return;
        const videoTile = Array.from(this.track.querySelectorAll('.krds-crompton-strip__player'))
          .map((el) => el.closest('.krds-crompton-strip__tile'))
          .find((tile) => tile && !tile.classList.contains('is-hidden'));
        if (videoTile) {
          const prevTile = videoTile.previousElementSibling;
          const crop = prevTile ? prevTile.offsetWidth * 0.25 : 0;
          this.track.scrollLeft = Math.min(Math.max(videoTile.offsetLeft - crop, 0), max);
        } else {
          this.track.scrollLeft = 0;
        }
      };
      requestAnimationFrame(() => requestAnimationFrame(set));
      if (!this._onResize) {
        this._onResize = () => set();
        window.addEventListener('resize', this._onResize);
      }
    }

    disconnectedCallback() {
      this.pills.forEach((pill) => pill.removeEventListener('click', this.onPillClick));
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._onCenterResize) window.removeEventListener('resize', this._onCenterResize);
      this.dragCleanups.forEach((cleanup) => cleanup());
      this.dragCleanups = [];
    }

    onPillClick(event) {
      const pill = event.currentTarget;
      const filter = pill.getAttribute('data-krds-crompton-pill');

      this.pills.forEach((p) => {
        const active = p === pill;
        p.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      this.tiles.forEach((tile) => {
        const category = tile.getAttribute('data-krds-crompton-tile');
        const show = filter === 'all' || category === filter;
        tile.classList.toggle('is-hidden', !show);
      });

      if (this.track) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
      }

      this.updateCentering();
    }

        updateCentering() {
      if (!this.track) return;
      requestAnimationFrame(() => {
        const overflowing = this.track.scrollWidth > this.track.clientWidth + 1;
        this.track.classList.toggle('is-centered', !overflowing);
      });
    }
  }

  customElements.define('krds-crompton-filter', CromptonFilter);
}

if (!customElements.get('krds-crompton-sonic-toggle')) {
  class CromptonSonicToggle extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.krds-crompton-sonic');
      this.silentVideo = this.section ? this.section.querySelector('.krds-crompton-sonic__video--silent') : null;
      this.soundVideo = this.section ? this.section.querySelector('.krds-crompton-sonic__video--sound') : null;
      this.triggerButton = this.querySelector('[data-krds-crompton-sonic-trigger]');
      this.muteButton = this.querySelector('[data-krds-crompton-sonic-mute]');
      this.replayButton = this.querySelector('[data-krds-crompton-sonic-replay]');
      this.soundActive = false;
      this.onTrigger = this.onTrigger.bind(this);
      this.onMute = this.onMute.bind(this);
      this.onReplay = this.onReplay.bind(this);
    }

    connectedCallback() {
      if (this.triggerButton) this.triggerButton.addEventListener('click', this.onTrigger);
      if (this.muteButton) this.muteButton.addEventListener('click', this.onMute);
      if (this.replayButton) this.replayButton.addEventListener('click', this.onReplay);
    }

    disconnectedCallback() {
      if (this.triggerButton) this.triggerButton.removeEventListener('click', this.onTrigger);
      if (this.muteButton) this.muteButton.removeEventListener('click', this.onMute);
      if (this.replayButton) this.replayButton.removeEventListener('click', this.onReplay);
    }

    onTrigger() {
      if (this.getAttribute('data-has-sound-video') !== 'true' || !this.soundVideo) return;
      this.soundActive = !this.soundActive;
      this.setAttribute('data-sound-active', this.soundActive ? 'true' : 'false');
      this.triggerButton.setAttribute('aria-pressed', this.soundActive ? 'true' : 'false');

      const label = this.triggerButton.querySelector('[data-krds-crompton-sonic-label]');
      if (label) {
        label.textContent = this.soundActive
          ? label.getAttribute('data-label-after')
          : label.getAttribute('data-label-before');
      }

      if (this.soundActive) {
        if (this.silentVideo) {
          this.silentVideo.classList.remove('is-active');
          this.silentVideo.pause();
        }
        this.soundVideo.classList.add('is-active');
        this.soundVideo.muted = false;
        this.soundVideo.currentTime = 0;
        this.soundVideo.play();
        if (this.muteButton) {
          this.muteButton.setAttribute('data-muted', 'false');
          this.muteButton.setAttribute('aria-pressed', 'false');
          this.muteButton.setAttribute('aria-label', 'Mute');
        }
      } else {
        this.soundVideo.classList.remove('is-active');
        this.soundVideo.pause();
        if (this.silentVideo) {
          this.silentVideo.classList.add('is-active');
          this.silentVideo.play();
        }
      }
    }

    onMute() {
      if (!this.soundActive || !this.soundVideo) return;
      const nowMuted = !this.soundVideo.muted;
      this.soundVideo.muted = nowMuted;
      this.muteButton.setAttribute('data-muted', nowMuted ? 'true' : 'false');
      this.muteButton.setAttribute('aria-pressed', nowMuted ? 'true' : 'false');
      this.muteButton.setAttribute('aria-label', nowMuted ? 'Unmute' : 'Mute');
    }

    onReplay() {
      const active = this.soundActive ? this.soundVideo : this.silentVideo;
      if (!active) return;
      active.currentTime = 0;
      active.play();
    }
  }

  customElements.define('krds-crompton-sonic-toggle', CromptonSonicToggle);
}

if (!customElements.get('krds-crompton-deck')) {
  class CromptonDeck extends HTMLElement {
    constructor() {
      super();
      this.autoplayDelay = parseInt(this.getAttribute('data-autoplay-delay'), 10) || 3000;
      this.animationDuration = parseInt(this.getAttribute('data-animation-duration'), 10) || 200;
      this.slides = Array.from(this.querySelectorAll('.krds-crompton-deck__slide'));
      this.order = this.slides.slice();
      this.isAnimating = false;
      this.autoplayTimer = null;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onTouchStart = this.onTouchStart.bind(this);
      this.onTouchEnd = this.onTouchEnd.bind(this);
    }

    connectedCallback() {
      if (this.slides.length < 2) return;
      this.applyRoles();
      this.slides.forEach((slide) => {
        slide.addEventListener('click', this.onClick);
        slide.addEventListener('keydown', this.onKeydown);
      });
      this.addEventListener('touchstart', this.onTouchStart, { passive: true });
      this.addEventListener('touchend', this.onTouchEnd, { passive: true });
      this.resetAutoplay();
    }

    disconnectedCallback() {
      if (this.autoplayTimer) clearTimeout(this.autoplayTimer);
      this.slides.forEach((slide) => {
        slide.removeEventListener('click', this.onClick);
        slide.removeEventListener('keydown', this.onKeydown);
      });
      this.removeEventListener('touchstart', this.onTouchStart);
      this.removeEventListener('touchend', this.onTouchEnd);
    }

    applyRoles() {
      this.order.forEach((slide, i) => {
        let role;
        if (i === 0) role = 'front';
        else if (i === 1) role = 'back';
        else role = 'hidden';
        slide.setAttribute('data-role', role);
      });
    }

    advance() {
      if (this.isAnimating) return;
      this.isAnimating = true;

      const leaving = this.order[0];
      leaving.classList.add('is-leaving');

      const finish = () => {
        leaving.classList.remove('is-leaving');
        this.order.push(this.order.shift());
        this.applyRoles();
        this.isAnimating = false;
      };

      if (this.prefersReducedMotion) {
        finish();
      } else {
        window.setTimeout(finish, this.animationDuration);
      }
    }

    resetAutoplay() {
      if (this.autoplayTimer) clearTimeout(this.autoplayTimer);
      const loop = () => {
        this.advance();
        this.autoplayTimer = window.setTimeout(loop, this.autoplayDelay);
      };
      this.autoplayTimer = window.setTimeout(loop, this.autoplayDelay);
    }

    manualAdvance() {
      this.advance();
      this.resetAutoplay();
    }

    onClick(event) {
      const slide = event.currentTarget;
      if (slide.getAttribute('data-role') === 'front') this.manualAdvance();
    }

    onKeydown(event) {
      const slide = event.currentTarget;
      if ((event.key === 'Enter' || event.key === ' ') && slide.getAttribute('data-role') === 'front') {
        event.preventDefault();
        this.manualAdvance();
      }
    }

    onTouchStart(event) {
      const t = event.changedTouches[0];
      this.touchStartX = t.clientX;
      this.touchStartY = t.clientY;
    }

    onTouchEnd(event) {
      const t = event.changedTouches[0];
      const dx = t.clientX - this.touchStartX;
      const dy = t.clientY - this.touchStartY;
      const SWIPE_THRESHOLD = 40;
      if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
        this.manualAdvance();
      }
    }
  }

  customElements.define('krds-crompton-deck', CromptonDeck);
}
